import RealEstatePricingCard from './real-estate-pricing-card'
export default RealEstatePricingCard
